import { Routes } from '@angular/router';

export const colAdminRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./col-admin.page').then((m) => m.ColAdminPage),
  },
];
